module.exports.env = 'prod'